import { render } from "./AdminL2.vue?vue&type=template&id=1741809d&scoped=true"
import script from "./AdminL2.vue?vue&type=script&lang=js"
export * from "./AdminL2.vue?vue&type=script&lang=js"

import "./AdminL2.vue?vue&type=style&index=0&id=1741809d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1741809d"]])

export default __exports__